package ui.component.external

import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.router.useNavigate
import ru.malygin.dto.MainScheduleItemDto
import ru.malygin.myConst.SelectedCategory
import ru.malygin.myConst.TimeDetectorItem
import ui.component.MainScreenComponentsOpen
import ui.component.buttons.iconButton
import ui.component.buttons.miniIconButton
import ui.router.RouterRoute
import ui.styles.Styles
import ui.styles.icons.CloseRoundedIconSVG
import ui.styles.icons.EditNoteIconSVG
import utils.logger.log
import web.cssom.*
import web.dom.document
import kotlin.text.Typography.times


external interface DialogBodyMIGProps: Props {
    var category: SelectedCategory
    var itemDto: List<MainScheduleItemDto>
    var timeDetectorItem: TimeDetectorItem
}

enum class Dialogs(
    val whatDialog: String,
    val titleMessage: String? = null,
    val bodyMessage: String? = null
) {
    DIALOG_MIG(
        whatDialog = "dialog_mig"
    ),
    DIALOG_ON_START(
        whatDialog = "dialog_on_start",
        titleMessage = "⚠️ Внимание ⚠️",
        bodyMessage = "Расписание не выбрано.\n Нажмите на кнопку ниже или на аналогичную справа сверху, чтобы перейти к выбору расписания."
    )
}

enum class DialogParams(
    val value: Any,
    val className: String? = null
){
    ID_DIALOG(
        "dialog_id_key",
        className = "dialog"
    ),
    ID_CONTENT(
        "dialog_content_id_key",
        className = "dialog_content"
    ),
    ID_HEADER(
        "dialog_header_id_key",
        className = "dialog_header"
    ),
    ID_BODY(
        "dialog_body_id_key",
        className = "dialog_body"
    ),
    ID_CLOSE_BUTTON(
        "dialog_close_button_id_key",
        className = "dialog_close_button"
    )
}

val dialogMIG = FC<DialogBodyMIGProps>{ props ->

    ReactHTML.div{
        id = "${DialogParams.ID_DIALOG.value}${props.itemDto.first().id}"
        className = ClassName(DialogParams.ID_DIALOG.className.toString())

        onClick = {event ->
            log.i("${event.target}| ${document.getElementById("${DialogParams.ID_DIALOG.value}${props.itemDto.first().id}")}  |${event.target == document.getElementById("${DialogParams.ID_DIALOG.value}${props.itemDto.first().id}")}")
            if (event.target == document.getElementById("${DialogParams.ID_DIALOG.value}${props.itemDto.first().id}")){
                dialogMigShow(
                    cls = "none",
                    whatDialog = Dialogs.DIALOG_MIG,
                    itemDto = props.itemDto
                )
            }

        }


        ReactHTML.div {
//        id = DialogParams.ID_CONTENT.value.toString()
            className = ClassName(DialogParams.ID_CONTENT.className.toString())


            miniIconButton{
                realIconSVG = CloseRoundedIconSVG
                onClick = {
                    dialogMigShow(
                        cls = "none",
                        whatDialog = Dialogs.DIALOG_MIG,
                        itemDto = props.itemDto
                    )
                }
            }

            ReactHTML.div {
                id = DialogParams.ID_HEADER.value.toString()
                className = ClassName(DialogParams.ID_HEADER.className.toString())

//                +"Dialog ${props.category}"//изменить padding в css, если добавлять текст
            }
            ReactHTML.div {
                id = DialogParams.ID_BODY.value.toString()

                className = ClassName(DialogParams.ID_BODY.className.toString())

                dialogBodyForMoreInfoGroups{
                    this.category = props.category
                    this.timeDetectorItem = props.timeDetectorItem
                    this.itemDto = props.itemDto
                }
            }
        }
    }
}


private val dialogBodyForMoreInfoGroups = FC<DialogBodyMIGProps>{props ->
    val msComponentsOpen = MainScreenComponentsOpen(props.category)
    ReactHTML.section{

        props.itemDto.forEach { itemDto ->
            ReactHTML.div{
                className = Styles.Elements.card

                css(this.className) {
                    marginInline = 0.px
                }


                ReactHTML.li{
                    className = Styles.Elements.listItem

                    msComponentsOpen.cardContent{
                        this.itemDto = itemDto
                        this.timeDetectorItem = props.timeDetectorItem
                    }
                }

            }
        }
    }
}

val dialogOnStart = FC{

    val navigate = useNavigate()

    ReactHTML.div{
        id = "${DialogParams.ID_DIALOG.value}${Dialogs.DIALOG_ON_START.whatDialog}"
        className = ClassName(DialogParams.ID_DIALOG.className.toString())

        onClick = {event ->
            log.i("${event.target}| " +
                    "${document.getElementById("${DialogParams.ID_DIALOG.value}${Dialogs.DIALOG_ON_START.whatDialog}")}| " +
                    "${event.target == document.getElementById("${DialogParams.ID_DIALOG.value}${Dialogs.DIALOG_ON_START.whatDialog}")}")

            if (event.target == document.getElementById("${DialogParams.ID_DIALOG.value}${Dialogs.DIALOG_ON_START.whatDialog}")){
                dialogMigShow(
                    cls = "none",
                    whatDialog = Dialogs.DIALOG_ON_START,
                    )
            }

        }


        ReactHTML.div {
//        id = DialogParams.ID_CONTENT.value.toString()
            className = ClassName(DialogParams.ID_CONTENT.className.toString())

            css(this.className) {
                height = 50.vh
//                animationName = "no_anim".unsafeCast<AnimationName>()
            }

            miniIconButton{
                realIconSVG = CloseRoundedIconSVG
                onClick = {
                    dialogMigShow(
                        cls = "none",
                        whatDialog = Dialogs.DIALOG_ON_START
                    )
                }
            }

            ReactHTML.div {
                id = DialogParams.ID_HEADER.value.toString()
                className = ClassName(DialogParams.ID_HEADER.className.toString())

                +Dialogs.DIALOG_ON_START.titleMessage
            }
            ReactHTML.div {
                id = DialogParams.ID_BODY.value.toString()

                className = ClassName(DialogParams.ID_BODY.className.toString())

                css(this.className) {
                    textAlign = TextAlign.center
                    display = Display.flex
                    flexDirection = FlexDirection.column
                    height = 100.pct
                    justifyContent = JustifyContent.center
                    alignItems = AlignItems.center
                    paddingBottom = 10.vh
                }

                ReactHTML.a{
                    css {
                        paddingBottom = 10.px
                    }
                    +Dialogs.DIALOG_ON_START.bodyMessage?.split("\n")?.first()
                }
                ReactHTML.a{
                    css {
                        paddingBottom = 10.px
                    }
                    +Dialogs.DIALOG_ON_START.bodyMessage?.split("\n")?.last()
                }

                iconButton{
                    this.realIconSVG = EditNoteIconSVG
                    this.plusMessageLeft = this.realIconSVG?.description
                    this.onClick = {
                        dialogMigShow(
                            cls = "none",
                            whatDialog = Dialogs.DIALOG_ON_START
                        )
                        navigate(RouterRoute.CHANGE_SCHEDULE.route)
                    }
                }
            }
        }
    }
}

fun dialogMigShow(
    cls: String = "block", // or none
    whatDialog: Dialogs,
    itemDto: List<MainScheduleItemDto>? = null
) {
    val dialog = when(whatDialog){
        Dialogs.DIALOG_MIG -> document.getElementById("${DialogParams.ID_DIALOG.value}${itemDto?.first()?.id}")
        Dialogs.DIALOG_ON_START -> document.getElementById("${DialogParams.ID_DIALOG.value}${whatDialog.whatDialog}")
    }


    dialog?.style?.display = cls
}
